/** @format */
import {TFunction} from 'i18next';

import {getSpentNumber} from 'features/tariffs/helpers/getSpentNumber';

const getMinBudgetDescription = (spentMax: number | null, t: TFunction): string => {
  if (spentMax === null) return '';

  const {spent, isMillion} = getSpentNumber(spentMax);

  return isMillion ? t('от {{spent}} млн ₽/месяц', {spent}) : t('от {{spent}} ₽/месяц', {spent});
};

export {getMinBudgetDescription};
